import { OvTableData } from '../../../components/UI/molecules/OvTable';
import Colours from '../../../design-system/colours';
import { UserCycle } from '../../model/dto/user-cycle/user-cycle';
import StringUtils from './string-utils';

export class UserCycleDataUtils {
  static mapUserCycleToTableData(userCycle?: UserCycle): OvTableData {
    return [
      {
        label: 'userCycles.fields.startDay',
        value: userCycle?.start_day,
        translateLabel: true,
      },
      {
        label: 'userCycles.fields.endDay',
        value: userCycle?.end_day,
        translateLabel: true,
      },

      {
        label: 'userCycles.fields.cycleLength',
        value: userCycle?.cycle_length,
        translateLabel: true,
      },

      {
        label: 'userCycles.fields.isOvulatoryCycle',
        value: userCycle?.is_ovulatory_cycle,
        translateLabel: true,
        prettifiedValue: StringUtils.getPrettifiedBooleanValue(
          userCycle?.is_ovulatory_cycle
        ),
      },
      {
        label: 'userCycles.fields.cycleDetails',
        value: !!userCycle?.cycle_details,
        translateLabel: true,
        nestedRows: [
          {
            label: 'userCycles.fields.ovulationPhaseStartDay',
            value: userCycle?.cycle_details?.ovulation_phase_start_day,
            translateLabel: true,
          },
          {
            label: 'userCycles.fields.lhRiseCycleDay',
            value: userCycle?.cycle_details?.lh_rise_cycle_day,
            translateLabel: true,
          },
          {
            label: 'userCycles.fields.pgRiseCycleDay',
            value: userCycle?.cycle_details?.pg_rise_cycle_day,
            translateLabel: true,
          },
          {
            label: 'userCycles.fields.lengthOfMenstrualPhase',
            value: userCycle?.cycle_details?.length_of_menstrual_phase,
            translateLabel: true,
          },

          {
            label: 'userCycles.fields.lengthOfFollicularPhase',
            value: userCycle?.cycle_details?.length_of_follicular_phase,
            translateLabel: true,
          },

          {
            label: 'userCycles.fields.lengthOfOvulationPhase',
            value: userCycle?.cycle_details?.length_of_ovulation_phase,
            translateLabel: true,
          },

          {
            label: 'userCycles.fields.lengthOfLutealPhase',
            value: userCycle?.cycle_details?.length_of_luteal_phase,
            translateLabel: true,
          },
        ],
        style: {
          backgroundColor: Colours.OV_LIGHT_GRAY,
        },
        showNestedRows: true,
      },
      {
        label: 'userCycles.fields.createdAt',
        value: userCycle?.created_at,
        translateLabel: true,
      },

      {
        label: 'userCycles.fields.updatedAt',
        value: userCycle?.updated_at,
        translateLabel: true,
      },
    ];
  }
}
